import React, { useState } from 'react'
import Button from '../../../../component/ui/Button';
import Modal from '../../../../component/modal/Modal';
import InputField from '../../../../component/form/FormInput';
import { createTransport } from '../../../../services/transport';
import useTransport from '../../hooks/useTransport';
import { toast } from 'react-toastify';

function AddTransportModal({ isTransportType, setIsTransportType, setIsTransportFocus, setPurchaseBillFormData }) {
  const [transportName, setTransportName] = useState("")
  const [errorTransportName, setErrortransportName] = useState('');
  const { setTransportList } = useTransport()

  const handleTransportType = async () => {
    try {
      if (transportName === '') {
        setErrortransportName('Please enter transport agency name!');
        return;
      }
      const data = await createTransport({ transport_name: transportName });
      const updatedTransportMethodList = [
        {
          key: data?.transport?.transport_name,
          value: data?.transport?.transport_name,
        },
      ]
      setTransportList(updatedTransportMethodList);

      setPurchaseBillFormData((prev) => ({
        ...prev,
        e_way_bill: {
          ...prev.e_way_bill,
          transport: data?.transport?.transport_name,
        },
      }));
      setTransportName('');
      setIsTransportType(false);
      setIsTransportFocus(true);
    } catch (error) {
      toast.error('Something went wrong! While Addding the transport name.');
    }
  };

  return (
    <Modal
      className="delivery-modal"
      title="Transport"
      isOpen={isTransportType}
      onClose={() => {
        setIsTransportType(false);
        setIsTransportFocus(true);
      }}
      cancelButton={true}
    >
      <p>
        <InputField
          label="Transport Name"
          placeholder="Enter Transport Name"
          autoComplete={'Transport'}
          name="Transport"
          value={transportName}
          autoFocus={true}
          onChange={(value) => {
            if (value !== '' && value !== null) {
              setTransportName(value);
              setErrortransportName('');
            } else {
              setTransportName('');
              setErrortransportName('Please enter transport type');
            }
          }}
          onKeyPress={(e) => {
            if ((e.key === 'Enter' || e.key === 'enter') && transportName !== '') {
              handleTransportType();
            }
          }}
          required={true}
          error={errorTransportName}
        />
      </p>

      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-end',
          marginTop: '20px',
        }}
      >
        <Button
          button="Cancel"
          type="button"
          className="btn btn-danger"
          onClick={() => {
            setIsTransportType(false);
            setIsTransportFocus(true);
          }}
        />
        <span style={{ width: '20px' }}></span>
        <Button
          button="OK"
          type="button"
          className="btn btn-primary"
          onClick={handleTransportType}
        />
      </div>
    </Modal>
  )
}

export default AddTransportModal